import { useEffect } from 'react';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { useQuery } from 'convex/react';
import { api } from '@repo/backend/convex/_generated/api';
import { LoadingPlaceholder } from '@components/loading-placeholder.tsx';
import { NotFoundComponent } from '@/components/NotFoundComponent.tsx';

export const Route = createFileRoute('/documents/$docId')({
  component: DocumentRedirectPage,
});

/**
 * Space-agnostic document URL: /documents/<id> resolves the document and
 * redirects to its page in whichever space it currently lives. This is the
 * form links in notes use, so a link keeps working when its target is moved
 * to another space, and a copied URL works when pasted into a browser.
 */
function DocumentRedirectPage() {
  const { docId } = useParams({ from: '/documents/$docId' });
  const navigate = useNavigate();
  const resolved = useQuery(api.public.documentFunctions.resolveDocumentLinks, { ids: [docId] });
  const target = resolved?.[docId];

  useEffect(() => {
    if (target) {
      void navigate({
        to: '/$spaceSlug/documents/$docId',
        params: { spaceSlug: target.spaceSlug, docId },
        replace: true,
      });
    }
  }, [target, docId, navigate]);

  if (resolved === undefined || target) {
    return <LoadingPlaceholder text="Finding your document..." />;
  }

  return <NotFoundComponent />;
}
